import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { FormattedMessage, useIntl } from 'react-intl';

// Redux
import { connect } from 'react-redux';

// Style
import { Grid, Row, Col } from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './Dashboard.css';
import bt from '../../components/commonStyle.css';

// Component
import UnreadMessages from './UnreadMessages';
import DashboardMenu from './DashboardMenu';
import DashBoardSideMenu from './DashBoardSideMenu';

// GraphQL
import UnreadThreadsQuery from './getUnreadThreads.graphql';
import { withQuery } from '../../hoc/withGraphql';

// Locale
import messages from '../../locale/messages';

// Images
import WavingHand from '/public/SiteIcons/wavingHand.png';

const Dashboard = (props) => {
  const { account: { userId, picture, firstName }, siteName, allUnreadThreads } = props;
  const { loading, getDashboardUnreadThreads } = allUnreadThreads || {};
  const { formatMessage } = useIntl();

  const newMessages = !loading && getDashboardUnreadThreads ? getDashboardUnreadThreads.length : 0;
  const messageCount = `${formatMessage(messages.messages)} (${newMessages} ${formatMessage(messages.messagesNew)})`;

  return (
    <Grid fluid className={cx(s.pageContainer, 'ViewProfile')}>
      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <div className={'dashBoardGrid'}>
            <div>
              <DashBoardSideMenu />
            </div>
            <div>
              <div className={cx('commonListingBg', 'dashboard')}>
                <h3 className={bt.listingTitleText}>
                  <span className={cx(s.waveHandImage, 'waveHandImageRTL')}>
                    <img src={WavingHand} />
                  </span>
                  <span className={s.waveHandImageSection}>
                    {formatMessage(messages.sayHelloTo)} {firstName && <> {firstName}</>}
                  </span>
                </h3>
                <p>
                  <span>{`${formatMessage(messages.sayHelloTo)} ${firstName || ''}!`}</span>{' '}
                  <FormattedMessage {...messages.dashBoardInfo} />
                </p>
                <p className={s.noMargin}><FormattedMessage {...messages.dashBoardInfo1} /></p>
              </div>
              <div>
                <DashboardMenu />
                <h4 className={s.messageCountText}>{messageCount}</h4>
                <UnreadMessages
                  userId={userId}
                  loading={loading}
                  getUnreadThreads={getDashboardUnreadThreads}
                />
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Grid>
  );
};

Dashboard.propTypes = {
  account: PropTypes.shape({
    userId: PropTypes.string.isRequired,
    picture: PropTypes.string,
    firstName: PropTypes.string,
  }).isRequired,
  allUnreadThreads: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    getDashboardUnreadThreads: PropTypes.array,
  }),
  siteName: PropTypes.string.isRequired,
};

Dashboard.defaultProps = {
  allUnreadThreads: {
    loading: true,
    getDashboardUnreadThreads: [],
  },
  account: {
    userId: null,
    picture: null,
    firstName: '',
  },
};

const mapState = (state) => ({
  account: state.account.data,
  siteName: state.siteSettings.data.siteName,
});

export default compose(
  withStyles(s, bt),
  connect(mapState),
  withQuery(UnreadThreadsQuery, {
    name: 'allUnreadThreads',
    options: {
      ssr: false,
      fetchPolicy: 'network-only',
    },
  })
)(Dashboard);